import { render } from "./contentUs.vue?vue&type=template&id=56a95f76&scoped=true"
import script from "./contentUs.vue?vue&type=script&lang=js"
export * from "./contentUs.vue?vue&type=script&lang=js"

import "./contentUs.vue?vue&type=style&index=0&id=56a95f76&scoped=true&lang=less"

import exportComponent from "D:\\workCode\\cbc\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a95f76"]])

export default __exports__